/** Deutsche Anzeige-Labels der Personalakte-Enums (backend/app/models/enums.py). */

import type {
  Anrede,
  EmailLabel,
  Geschlecht,
  Mitarbeitertyp,
  RufnummerLabel,
  TaetigkeitArt,
  WohnsitzArt,
} from "@/types"

export const GESCHLECHT_LABEL: Record<Geschlecht, string> = {
  MAENNLICH: "Männlich",
  WEIBLICH: "Weiblich",
  DIVERS: "Divers",
}

export const ANREDE_LABEL: Record<Anrede, string> = {
  HERR: "Herr",
  FRAU: "Frau",
}

export const MITARBEITERTYP_LABEL: Record<Mitarbeitertyp, string> = {
  INTERNER_MITARBEITER: "Interner Mitarbeiter",
  EXTERNER_BERATER: "Externer Berater",
  ZEITARBEITNEHMER: "Zeitarbeitnehmer",
  RENTNER: "Rentner",
}

export const RUFNUMMER_LABEL: Record<RufnummerLabel, string> = {
  GESCHAEFTLICH: "Geschäftlich",
  FESTNETZ: "Festnetz",
  MOBIL: "Mobil",
  ANDERE: "Andere",
}

export const EMAIL_LABEL: Record<EmailLabel, string> = {
  PRIVAT: "Privat",
  GESCHAEFTLICH: "Geschäftlich",
}

export const WOHNSITZ_LABEL: Record<WohnsitzArt, string> = {
  ERSTER_WOHNSITZ: "Erster Wohnsitz",
  ZWEITER_WOHNSITZ: "Zweiter Wohnsitz",
}

export const TAETIGKEIT_LABEL: Record<TaetigkeitArt, string> = {
  HAUPTTAETIGKEIT: "Haupttätigkeit",
  ZWEITE_TAETIGKEIT: "Zweite Tätigkeit",
}

/** Record<Enum,string> → Select-Optionen */
export function toOptions<K extends string>(
  labels: Record<K, string>
): { value: K; label: string }[] {
  return (Object.keys(labels) as K[]).map((value) => ({ value, label: labels[value] }))
}
